import PaymentPlans from './PaymentPlans'

export default PaymentPlans
